// extracted by mini-css-extract-plugin
export var boldText = "_6y-4";
export var checkboxContainer = "_6y-6";
export var closeIcon = "_6y-i";
export var container = "_6y-0";
export var drawer = "_6y-8";
export var drawerContent = "_6y-9";
export var extraSmallText = "_6y-5";
export var fulfillmentGroupTable = "_6y-e";
export var largeText = "_6y-3";
export var loadingSpinnerContainer = "_6y-j";
export var mediumText = "_6y-2";
export var narrow = "_6y-f";
export var notificationLink = "_6y-l";
export var packageCheckIconContainer = "_6y-7";
export var slideoutHeaderActions = "_6y-g";
export var slideoutHeaderActionsShifted = "_6y-h";
export var slideoutHeaderContainer = "_6y-a";
export var slideoutModal = "_6y-c";
export var stickyHeaderWrapper = "_6y-b";
export var table = "_6y-k";
export var tableContainer = "_6y-d";
export var tertiaryText = "_6y-1";